module.exports = __webpack_public_path__ + "img/Serbia.1c2b75fd.svg";